import React, { useEffect, useState } from "react";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import CommonCard from "../common/commonCard";
import { Container, Row, Col } from "react-bootstrap";
import CaseCard from "../specific/caseCard";
import CustomTable from "../common/table";
import Footer from "../common/footer";
import { GetIncidentsUResponsibleService } from "../../Services/incidentService";
import { GetCompaniesService } from '../../Services/companyService';
import { GetIncidentStatesService } from "../../Services/selectFieldsService";
import { useTranslation } from "react-i18next";
import CustomTabs, { CustomTab } from "../common/customTabs";
import PopUpFeedback from "../specific/popUpFeedback";
import { GetFeedbacksService } from "../../Services/feedbackService";
import CaseMetrics from "../specific/caseMetrics";
import { formatTimeToSpanishTimeZone, formatToSpanishTimeZone } from "../../utils/formatDate";

function IncidentMain() {
  const [t] = useTranslation("incidents")
  const [expanded, setExpanded] = useState(false);
  const [companiesNames, setCompaniesNames] = useState([]);
  const [workPlaces, setWorkPlaces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [incidentsCreatedAt, setIncidentsCreatedAt] = useState([]);
  const [cardFilter, setCardFilter] = useState(null);
  const [notAdmitted, setNotAdmitted] = useState("--");
  const [running, setRunning] = useState("--");
  const [waitingResolution, setWaitingResolution] = useState("--");
  const [solved, setSolved] = useState("--");
  const [canceled, setCanceled] = useState("--");
  const [total, setTotal] = useState("--");
  const [incidentsData, setIncidentsData] = useState([]);
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingFeedback, setLoadingFeeedback] = useState(true);
  const [defaultTab, setDefaultTab] = useState(true);
  const [filteredDataFromTable, setFilteredDataFromTable] = useState([]); //Datos filtrados desde <CustomTable/>
  const [feedbackPopupData, setFeedbackPopupData] = useState([]);
  const [feedbackShowPopup, setFeedbackShowPopup] = useState(false);
  const [reloadCaseMetricsData, setReloadCaseMetricsData] = useState(false);

  async function fetchData() {
    setLoading(true)

    try {
      setCategories([]);
      setStates([]);
      setIncidentsData([]);
      setIncidentsCreatedAt([]);
      setCompaniesNames([])
      setWorkPlaces([]);
      const response = await GetIncidentsUResponsibleService();

      let categoriesBdd = [];
      let maxCategoriesLength = 0;

      response.forEach(item => {
        if (item.incidentCategories.length > maxCategoriesLength) {
          maxCategoriesLength = item.incidentCategories.length;
          categoriesBdd = item.incidentCategories;
        }
      });

      const names = [];
      response.forEach((item) => {
        if (item.company && !names.includes(item.company)) {
          names.push(item.company);
        }
      });
      const years = response.map(incident => incident.createdAt.split('/')[2]).filter((name, index, self) => self.indexOf(name) === index); // Solo los que no se repitan
      const workPlaceNames = [];
      response.forEach((item) => {
        if (item.workPlace && !workPlaceNames.includes(item.workPlace)) {
          workPlaceNames.push(item.workPlace);
        }
        item.createdAt = formatToSpanishTimeZone(item.createdAt)
      });


      let statesBdd = await GetIncidentStatesService();

      setCategories(categoriesBdd);
      setStates(statesBdd);
      setIncidentsData(response);
      setIncidentsCreatedAt(years);
      setCompaniesNames(names)
      setWorkPlaces(workPlaceNames);
      setLoading(false)
    } catch (error) {

      setLoading(false)
      console.error(error);
    }
  }


  const handleReloadData = () => {
    setReloadCaseMetricsData(!reloadCaseMetricsData)
    fetchData();
  };

  useEffect(() => {

    fetchData()

  }, []);

  useEffect(() => {

    setDefaultTab(!defaultTab)

  }, [cardFilter]);

  //obtener los datos de la cantidad de casos
  useEffect(() => {
    // const stateCounts = {
    //   "Pendiente": 0,
    //   "En curso": 0,
    //   "Pendiente de resolución": 0,
    //   "Cancelado" : 0,
    //   "Resuelto": 0
    // };

    const stateCounts = {};
    stateCounts[states[2]] = 0;
    stateCounts[states[1]] = 0;
    stateCounts[states[3]] = 0;
    stateCounts[states[0]] = 0;
    stateCounts[states[4]] = 0;

    filteredDataFromTable.forEach((e) => {
      if (stateCounts.hasOwnProperty(e.state)) {
        stateCounts[e.state]++;
      } else {
        console.error(`Estado de incidente no reconocido: ${e.incident.state}`);
      }
    });

    // Asignar valores a los estados
    setNotAdmitted(stateCounts[states[2]]);
    setRunning(stateCounts[states[1]]);
    setWaitingResolution(stateCounts[states[3]]);
    setSolved(stateCounts[states[4]]);
    setCanceled(stateCounts[states[0]]);
    setTotal(filteredDataFromTable.length);

  }, [filteredDataFromTable]); // Dependencia del useEffect

  const handleFilteredDataChange = (newFilteredData) => {
    setFilteredDataFromTable(newFilteredData);
  }

  const columnHeaders = [
    `${t("listCard.createdAt")}`,
    `${t("listCard.limitDateAd")}`,
    `${t("listCard.limitDateRes")}`,
    `${t("listCard.remainingDays")}`,
    `${t("listCard.state")}`,
    `${t("listCard.category")}`,
    `${t("listCard.company")}`,
    `${t("listCard.activityNumber")}`,
  ];

  const columnHeadersFeedback = [
    `${t("listCard.createdAt")}`,
    `${t("listCard.company")}`,
    `${t("listCard.feedbackTitle")}`,
  ];

  const fieldsToShow = [
    "createdAt",
    "limitDateAd",
    "limitDateRes",
    "remainingDays",
    "state",
    "category",
    "company",
    "activityNumber"
  ];

  const fieldsToShowFeedback = [
    "createdAt",
    "company",
    "title"
  ];



  const optionArrays = [
    incidentsCreatedAt,
    [],
    [],
    [],
    states,
    categories,
    companiesNames,
    workPlaces,
  ];

  if (workPlaces.length > 0) {
    const columnIndexToAddInHeaders = 7;
    const fieldIndexToAddInFields = 7;

    columnHeaders.splice(columnIndexToAddInHeaders, 0, t("listCard.workPlace"));
    fieldsToShow.splice(fieldIndexToAddInFields, 0, "workPlace");
  }

  const handleFeedbackViewClicked = (data) => {
    setFeedbackPopupData(data)
    setFeedbackShowPopup(true)
  };

  const handlePopUpFeedbackViewClose = () => {
    setFeedbackShowPopup(false)
    setFeedbackPopupData(null)
  }

  const handleTabClick = async (idTab) => {
    setLoadingFeeedback(true)
    if (idTab = "feedbackTab") {
      const feedback = await GetFeedbacksService();
      setFeedbackData(feedback)
      setLoadingFeeedback(false)
    }
    setLoadingFeeedback(false)

  }

  return (
    <>
      <PopUpFeedback
        show={feedbackShowPopup}
        handleClose={handlePopUpFeedbackViewClose}
        onClickButton={handlePopUpFeedbackViewClose}
        data={feedbackPopupData}
      />



      <div>
        <Header
          manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
          reloadData={handleReloadData}
        />
        <Container fluid>
          <Row>
            <Col
              className='d-flex'
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                flex: `0 0 ${expanded ? "2%" : "4%"}`,
              }}
            >
              <Sidebar
                expanded={expanded}
                setExpanded={setExpanded}
                selected={"Casos"}
              />
            </Col>
            <Col
              className='custom-content-wrapper'
              style={{
                marginLeft: `0.5%`,
                paddingRight: 0,
                flex: `0 0 ${expanded ? "86%" : "93%"}`,
              }}
            >
              {/* Primer CommonCard */}
              <CommonCard title={t("summaryCard.title")} icon="FaChartPie">
                <CustomTabs setDefaultTab={true} >
                  <CustomTab title={t("listCard.quickView")} icon="FaRegObjectGroup" >
                    <div className="common-card-card-content-card">
                      <CaseCard
                        numberCase={notAdmitted}
                        caseType={t("summaryCard.notAdmitted")}
                        statusColor={"red"}
                        onCardClick={() =>
                          setCardFilter({ field: "state", value: states[2] })
                        }
                      />
                      <CaseCard
                        numberCase={running}
                        caseType={t("summaryCard.running")}
                        statusColor={"yellow"}
                        onCardClick={() =>
                          setCardFilter({ field: "state", value: states[1] })
                        }
                      />
                      <CaseCard
                        numberCase={waitingResolution}
                        caseType={t("summaryCard.waitingResolution")}
                        statusColor={"blue"}
                        onCardClick={() =>
                          setCardFilter({
                            field: "state",
                            value: states[3]
                          })
                        }
                      />
                      <CaseCard
                        numberCase={solved}
                        caseType={t("summaryCard.solved")}
                        statusColor={"green"}
                        onCardClick={() =>
                          setCardFilter({ field: "state", value: states[4] })
                        }
                      />
                      <CaseCard
                        numberCase={canceled}
                        caseType={t("summaryCard.canceled")}
                        statusColor={"lightGray"}
                        onCardClick={() =>
                          setCardFilter({ field: "state", value: states[0] })
                        }
                      />
                      <CaseCard
                        numberCase={total}
                        caseType={t("summaryCard.total")}
                        statusColor={"gray"}
                        onCardClick={() => setCardFilter()}
                      />
                    </div>
                  </CustomTab>
                  <CustomTab title={t("listCard.metrics")} icon="FaChartLine">
                    <CaseMetrics key={reloadCaseMetricsData} reloadData={reloadCaseMetricsData} />
                  </CustomTab>
                </CustomTabs>
              </CommonCard>


              <CommonCard title={t("listCard.title")} icon="FaColumns">


                <CustomTabs setDefaultTab={defaultTab} onTabClick={handleTabClick}>
                  <CustomTab title={t("listCard.incidents")} icon="FaBullhorn" >
                    <div className="common-card-card-content-card center-number-activity">
                      <CustomTable
                        key={loading}
                        cardFilter={cardFilter}
                        columnHeaders={columnHeaders}
                        fieldsToShow={fieldsToShow}
                        data={incidentsData}
                        navigateTo={"/incident"}
                        optionArrays={optionArrays}
                        excelButton={true}
                        loading={loading}
                        onFilteredDataChange={handleFilteredDataChange}
                      />
                    </div>
                  </CustomTab>
                  <CustomTab title={t("listCard.feedback")} icon="FaEnvelope" id="feedbackTab">
                    <div className="common-card-card-content-card center-number-activity">
                      <CustomTable
                        key={loadingFeedback}
                        columnHeaders={columnHeadersFeedback}
                        fieldsToShow={fieldsToShowFeedback}
                        data={feedbackData}
                        optionArrays={[]}
                        loading={loadingFeedback}
                        displayFilter={false}
                        viewButton
                        feedbackTable
                        displayPopUp={handleFeedbackViewClicked}

                      />
                    </div>
                  </CustomTab>
                </CustomTabs>
              </CommonCard>
              <Footer />
            </Col>
          </Row>
        </Container>
      </div >
    </>
  );
}

export default IncidentMain;